import styles from './registration-conflict-dialog.module.scss';
import { makeCourseRequest } from '../../../requestUtils';
import { Dialog, DialogActions, DialogContent, DialogTitle, PrimaryButton, Skeleton } from '@frontend-workspace/react-shared-lib';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

/* eslint-disable-next-line */
export interface RegistrationConflictDialogProps {
  onClose: () => void,
  open: boolean,
  refreshData: () => void,
  errorText: string
}

export function RegistrationConflictDialog(props: RegistrationConflictDialogProps) {
  //const [tooltip, setTooltip] = useState<string>('');
  const { t } = useTranslation();

  // useEffect(() => {
  //   const tooltip = (props.errorText).join('');
  //   makeCourseRequest(`course/registrations/conflict/tooltip/${tooltip}`, 'GET')
  //     .then((result: string) => {
  //       setTooltip(result || `${t("registrationConflict.noDataFound")}`);
  //     }).catch((error) => console.log('Error: ' + error));
  // }, [props.errorText]);

  return (
    <Dialog
      open={props.open}
      onClose={props.onClose}
      maxWidth="xl">
      <DialogTitle className='mb-4'>
        {t("registrationConflict.conflicts")}
      </DialogTitle>
      <DialogContent>
        {!props.errorText ? <Skeleton variant="rectangular" animation="wave" width={500} height={300} /> :
          <pre>{props.errorText}</pre>
        }
      </DialogContent>
      <DialogActions>
        <PrimaryButton
          variant="contained"
          size='large'
          onClick={props.onClose}
          className='minButtonWidth'>
          OK
        </PrimaryButton>
      </DialogActions>
    </Dialog>
  );
}

export default RegistrationConflictDialog;
